/*
 * File: storage.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:43 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 21, 2025 at 9:05 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import * as Sentry from '@sentry/react';


/**
 * Utilities
 */

export const storeItem = (key, value) => {
	try {
		window.localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
	} catch (e) { Sentry.captureException(e); }
};

export const getStorageItem = (key) => {
	try {
		const content = window.localStorage.getItem(key);
		try {
			const json = JSON.parse(content);
			return json;
		} catch (_) {}
		return content;
	} catch (e) { Sentry.captureException(e); }
	return null;
};

export const removeStorageItem = (key) => {
	try {
		window.localStorage.removeItem(key);
	} catch (e) { Sentry.captureException(e); }
};

export const clearSessionStorage = () => {
	try {
		window.localStorage.clear();
	} catch (e) { Sentry.captureException(e); }
};
